import * as React from 'react';
import * as acl from 'common/utils/acl';

import { Block, Row } from 'emotion-jsxstyle';

import { AppState } from 'common/models/AppState';
import { SidebarNavLink } from './SidebarNavLink';
import { UserPermissions } from 'common/api/models/UserPermissions';

import { Member } from 'common/api/models/Member';
import { LinkProps } from 'react-router-dom';

export interface SidebarGroupItemProps {
  name: React.ReactNode | ((viewer: Member) => React.ReactNode);
  link: LinkProps['to'];
  iconName: string;
  enabled?: boolean;
  permission?: UserPermissions.Permissions;
  externalLink?: string;
  blockAdminType?: UserPermissions.Permissions;
}

export interface SidebarGroupProps {
  viewer: Member;
  name: string;
  link?: string;
  isOpen?: string;
  kids: SidebarGroupItemProps[];
}
interface AppStateProps {
  appState: AppState;
}
// tslint:disable:jsx-alignment
export class SidebarGroup extends React.Component<SidebarGroupProps & AppStateProps & { onClose: () => void }, {}> {
  public render() {
    const { kids, name, appState, viewer } = this.props;
    return (
      <Block marginBottom="1rem" position="relative">
        <Block
          padding=".25rem 1rem"
          textTransform="uppercase"
          color="#ACB3C2"
          fontSize=".75rem"
          fontWeight="bold"
          letterSpacing=".08em"
        >
          {name}
        </Block>
        {kids
          .filter((child: SidebarGroupItemProps) => !child.permission || acl.hasPermission(appState, child.permission))
          .filter(
            (child: SidebarGroupItemProps) =>
              !child.blockAdminType || (child.blockAdminType && viewer.adminAccess)
                ? child.blockAdminType !== viewer.adminAccess
                : true
          )
          .map((child: SidebarGroupItemProps, i) => (
            <span key={i}>
              {child.enabled &&
                !child.externalLink && (
                  <SidebarNavLink
                    key={typeof child.link === 'object' ? child.link.pathname : child.link}
                    to={child.link}
                    onClick={this.props.onClose}
                  >
                    <Row
                      component="span"
                      padding=".5rem 1rem"
                      css={{ '@media (min-width: 768px)': { padding: '.25rem 1rem' } }}
                    >
                      <Block component="span" width={24}>
                        <i style={{ width: 16 }} className={`fa fa-${child.iconName} fa-small`} />
                      </Block>
                      <Block component="span" flex="1">
                        {typeof child.name === 'function' ? child.name(this.props.viewer) : child.name}
                      </Block>
                    </Row>
                  </SidebarNavLink>
                )}

              {child.name === 'WooCommerce Orders' &&
              this.props.appState.config &&
              this.props.appState.config.config.enableWooCommerce === false
                ? (child.enabled = false)
                : (child.enabled = child.enabled)}

              {child.enabled &&
                !!child.externalLink && (
                  <a href={child.externalLink} target="_blank" rel="external-link">
                    <Row
                      component="span"
                      padding=".5rem 1rem"
                      css={{ '@media (min-width: 768px)': { padding: '.25rem 1rem' } }}
                    >
                      <Block component="span" width={24}>
                        <i style={{ width: 16 }} className={`fa fa-${child.iconName} fa-small`} />
                      </Block>
                      <Block component="span" flex="1">
                        {typeof child.name === 'function' ? child.name(this.props.viewer) : child.name}
                      </Block>
                    </Row>
                  </a>
                )}
            </span>
          ))}
      </Block>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Navigator/SidebarGroup.tsx